import { INTL_CURRENCY_FORMAT, INTL_VOLUME_FORMAT } from '../App';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

const CURRENCY_ID_EUR = 'EUR';
export const CURRENCY_ID_CZK = 'CZK';
export const MWH = 'MWh';

export const useFormatPriceForMWh = (currencyId) => {
  const formatCurrencyFunc = useFormatCurrency(currencyId);
  return useCallback((price) => {
    return `${formatCurrencyFunc(price)} / ${MWH}`;
  }, [formatCurrencyFunc]);
};

export const useFormatCurrency = (currencyId) => {
  const intl = useIntl();
  return useCallback((value) => {
    return formatCurrency(intl, currencyId, value);
  }, [intl, currencyId]);
};

export const formatCurrency = (intl, currencyId, value) => {
  const format = currencyId === CURRENCY_ID_EUR ? INTL_CURRENCY_FORMAT.EUR : INTL_CURRENCY_FORMAT.CZK;
  return `${intl.formatNumber(value, {
    format: format,
  })} ${currencyId}`;
};

export const formatVolume = (intl, volume) => {
  return `${intl.formatNumber(volume, {
    format: INTL_VOLUME_FORMAT,
  })} ${MWH}`;
};
